import { Component, ElementRef, Input, Output, OnInit, ViewChild, EventEmitter, OnChanges } from '@angular/core';
import { GlobalConstants } from './../../../common/constants/global.constant';

@Component({
  selector: 'iposcen-ipos-help-asset-library',
  templateUrl: './ipos-help-asset-library.component.html',
  styleUrls: ['./ipos-help-asset-library.component.scss']
})
export class IposHelpAssetLibraryComponent implements OnInit, OnChanges {
  @Output() sideNav = new EventEmitter();
  @Input() helpToAsset;
  @Input() sideNavData;
  @ViewChild('top') top: ElementRef;
  @ViewChild('promoContent') promo: ElementRef;
  @ViewChild('segment') segments: ElementRef;
  @ViewChild('banner') banners: ElementRef;
  @ViewChild('priceContent') price: ElementRef;
  @ViewChild('storeLogo') store: ElementRef;
  @ViewChild('attractorAsset') attractorLoops: ElementRef;
  @ViewChild('main') mainTile: ElementRef;

  isStoreLogos = true;
  isPromoContent = true;
  isSegements = true;
  isBannerCarousel = true;
  isPriceContent = true;
  isAttractLoop = true;
  isMainTileasset = true;
  loginUserRole = sessionStorage.getItem('userRole');
  formFactorChangeText = GlobalConstants.NOTE_FORM_FACTORS_HELP;
  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges(): void {

    if (this.helpToAsset === 'promo') {
      this.scrollPromo();
    } else if (this.helpToAsset === 'segment') {
      this.scrollSegment();
    } else if (this.helpToAsset === 'banner') {
      this.scrollBanner();
    } else if (this.helpToAsset === 'priceContent') {
      this.scrollPrice();
    } else if (this.helpToAsset === 'storeLogo') {
      this.scrollStore();
    } else if (this.helpToAsset === 'attractor') {
      this.scrollAttractorLoopVideo();
    } else if (this.helpToAsset === 'main') {
      this.scrollMainTileAsset();
    }
  }

  change(data) {
    if (data === 'promo') {
      this.scrollPromo();
    } else if (data === 'segment') {
      this.scrollSegment();
    } else if (data === 'banner') {
      this.scrollBanner();
    } else if (data === 'price') {
      this.scrollPrice();
    } else if (data === 'store') {
      this.scrollStore();
    } else if (data === 'attractor') {
      this.scrollAttractorLoopVideo();
    } else if (data === 'main') {
      this.scrollMainTileAsset();
    }
  }
  showDescription(data) {
    if (data === 'storeLogos') {
      this.isStoreLogos = !this.isStoreLogos;
    } else if (data === 'promoContent') {
      this.isPromoContent = !this.isPromoContent;
    } else if (data === 'segments') {
      this.isSegements = !this.isSegements;
    } else if (data === 'bannerCarousel') {
      this.isBannerCarousel = !this.isBannerCarousel;
    } else if (data === 'priceContent') {
      this.isPriceContent = !this.isPriceContent;
    } else if (data === 'attractLoop') {
      this.isAttractLoop = !this.isAttractLoop;
    } else if (data === 'mainTileAsset') {
      this.isMainTileasset = !this.isMainTileasset;
    }
  }
  scrollPromo() {
    setTimeout(_ => {
      this.promo.nativeElement.scrollIntoView();
    }, 0);
  }
  scrollSegment() {
    setTimeout(_ => {
      this.segments.nativeElement.scrollIntoView();
    }, 0);
  }
  scrollBanner() {
    setTimeout(_ => {
      this.banners.nativeElement.scrollIntoView();
    }, 0);
  }
  scrollPrice() {
    setTimeout(_ => {
      this.price.nativeElement.scrollIntoView();
    }, 0);
  }
  scrollStore() {
    setTimeout(_ => {
      this.store.nativeElement.scrollIntoView();
    }, 0);
  }
  scrollAttractorLoopVideo() {
    setTimeout(_ => {
      this.attractorLoops.nativeElement.scrollIntoView();
    }, 0);
  }
  scrollMainTileAsset() {
    setTimeout(_ => {
      this.mainTile.nativeElement.scrollIntoView();
    }, 0);
  }

  navigate() {
    this.sideNav.emit(['customContentToIpos', '', '']);
  }
}
